class StickyProductBar extends HTMLElement {
  constructor() {
    super();

    this.mainForm = null;
    this.observer = null;
    this.offerObserver = null;
    this.offerSyncTimer = null;
  }

  connectedCallback() {

    /* =========================================
       FIND MAIN PRODUCT FORM
    ========================================= */

    this.mainForm =
      document.querySelector('product-info product-form') ||
      document.querySelector('.product-form__buttons');

    if (this.mainForm) {

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {

            this.classList.toggle(
              'is-visible',
              !entry.isIntersecting &&
              entry.boundingClientRect.top < 0
            );

          });
        },
        { threshold: 0 }
      );

      this.observer.observe(this.mainForm);

    } else {

      window.addEventListener(
        'scroll',
        this.fallbackScroll.bind(this),
        { passive: true }
      );

    }

    this.bindSubmit();
    this.bindOfferSync();
  }


  fallbackScroll() {
    this.classList.toggle(
      'is-visible',
      window.scrollY > 600
    );
  }


  /* =========================================
     CTA USES REAL MAIN PRODUCT BUTTON
  ========================================= */

  bindSubmit() {

    const stickyButton =
      this.querySelector('[data-sticky-submit]');

    if (!stickyButton) return;

    stickyButton.addEventListener('click', () => {

      const mainButton =
        document.querySelector(
          'product-info product-form .product-form__submit'
        );

      if (!mainButton) {
        console.warn(
          'Purple Ocean: main purchase button not found.'
        );
        return;
      }

      mainButton.click();

    });
  }


  /* =========================================
     READ PRICE FROM ESSENTIAL
  ========================================= */

  getOptionPrice(option) {

    const priceEl =
      option.querySelector('.essub-pricing__sale');

    if (!priceEl) return '';

    const textNode =
      Array.from(priceEl.childNodes).find(
        node =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim()
      );

    const raw =
      textNode
        ? textNode.textContent.trim()
        : priceEl.textContent.trim();

    return raw
      .replace('/bag', '')
      .trim();
  }


  /* =========================================
     UPDATE STICKY
  ========================================= */

  updateOfferDisplay() {

    const checked =
      document.querySelector('.essub-radio:checked');

    if (!checked) return;

    const option =
      checked.closest(
        '.essub-option--expanded, .essub-option--compact'
      );

    if (!option) return;

    const index = option.dataset.optionIndex;
    const price = this.getOptionPrice(option);

    const titleEl =
      this.querySelector('[data-sticky-offer-title]');

    const metaEl =
      this.querySelector('[data-sticky-offer-meta]');

    const badgeEl =
      this.querySelector('[data-sticky-offer-badge]');

    const buttonPriceEl =
      this.querySelector('[data-sticky-button-price]');


    let title = '';
    let meta = '';
    let badge = '';
    let buttonPrice = '';


    /* BUY 2 + GET 1 */

    if (index === '0') {

      title = 'Buy 2 + Get 1 FREE';
      badge = 'SAVE 47%';
      meta = `${price}/bag · 3 bags`;
      buttonPrice = `${price}/BAG`;

    }


    /* 1 MONTH */

    else if (index === '1') {

      title = '1-Month Supply';
      badge = 'SAVE 20%';
      meta = `${price}/bag · SAVE 20%`;
      buttonPrice = `${price}/BAG`;

    }


    /* ONE TIME */

    else if (index === '2') {

      title = 'One-Time Purchase';
      badge = '';
      meta = `1 bag · ${price}`;
      buttonPrice = price;

    }


    if (titleEl) {
      titleEl.textContent = title;
    }

    if (metaEl) {
      metaEl.textContent = meta;
    }

    if (badgeEl) {
      badgeEl.textContent = badge;
      badgeEl.style.display =
        badge ? 'inline-flex' : 'none';
    }

    if (buttonPriceEl) {
      buttonPriceEl.textContent = buttonPrice;
    }

  }


  /* =========================================
     WATCH ESSENTIAL
  ========================================= */

  bindOfferSync() {

    const scheduleSync = () => {

      clearTimeout(this.offerSyncTimer);

      this.offerSyncTimer =
        setTimeout(
          () => this.updateOfferDisplay(),
          80
        );

    };


    document.addEventListener(
      'change',
      (event) => {

        if (event.target.matches('.essub-radio')) {
          scheduleSync();
        }

      }
    );


    document.addEventListener(
      'click',
      (event) => {

        if (
          event.target.closest(
            '.essub-option--expanded, .essub-option--compact'
          )
        ) {
          scheduleSync();
        }

      }
    );


    this.offerObserver =
      new MutationObserver(scheduleSync);

    this.offerObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    this.updateOfferDisplay();

    setTimeout(
      () => this.updateOfferDisplay(),
      300
    );

    setTimeout(
      () => this.updateOfferDisplay(),
      1000
    );

  }
}


customElements.define(
  'sticky-product-bar',
  StickyProductBar
);